var TemplateLibraryTemplatesEmptyView;

TemplateLibraryTemplatesEmptyView = Marionette.ItemView.extend( {
	id: 'kitbuilder-template-library-templates-empty',

	template: '#tmpl-kitbuilder-template-library-templates-empty'
} );

module.exports = TemplateLibraryTemplatesEmptyView;
